import FdlButton from "../../buttons/FdlButton";
import FormField from "../../formfield/FormField";
import React, {useState, useEffect} from 'react';

import { Modal } from "@mui/material";
import { Box } from "@mui/system";

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import {useFetch} from '../../../components/auth/useFetch';



export default function EditFramingIntentModal(props) {
    const { open, handleClose, intentName, intentData, setIntentData } = props
    const fetchWithAuth = useFetch()

    let oldLabel;
    // Preven the below from running when the modal is created (on the full form page load)
    if (Object.keys(intentName) != 0){
        // Search intent data for the intent name of the intent being edited in this modal
        // record the current name of the intent so that we can use it
        // in our submit verification request.
        // This allows the verification endpoint to allow us to submit an edit for this intent
        // even if the edited data contains the same intent label as the intent initially had.
        // Previously the verification endpoint would detect this as 'intent label already exists', which
        // is faulty behaviour.
            if (Object.keys(intentData) != 0){
                oldLabel = intentData[intentName]['Intent Label']
            }
        }

    const [formErrorText, setFormErrorText] = useState('');

    let intents = {};

    if (intentData[intentName] !== undefined) {
        intents = intentData[intentName];
    } else {
        intents = {};
    };

    const modalPosition = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    
    const modalContainer = {
        bgcolor: 'black',
        border: '2px solid #000',
        boxShadow: 24,
        borderRadius: 8,
        p: 4,
        width: '35%',
        height: '50%'
    };
    
    const formErrorTextStyle = {
        opacity: formErrorText? 0.7 : 0,
        width: '70%',
        marginTop: '15px'
    }
    
    const cancelButtonStyle = {
        backgroundColor: 'red'
    };
    
    const bottomButtonContainer = {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    };





    async function handleSubmit(event) {
        event.preventDefault();


        const data = new FormData(event.currentTarget);
        
        let newKey = 'Error, no label entered';
        let newData = {};
        for (const entry of data.entries()) {
            if (entry !== undefined) {
                if (entry[0] === 'Intent Label') {
                    newKey = entry[1]
                } else {
                    newData[`${entry[0]}`] = entry[1]
                }
            }
        }


        let fetchDetails = {
            method: "POST",
            body: JSON.stringify({
                'dataType': 'intent', 
                'data': newData,
                'oldLabel': oldLabel,
                'allIntentsData': intentData,
                'action': 'create'
            }),
            headers: { "Content-type": "application/json; charset=UTF-8" }
        };
            
        let response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlvalidateinputone/`, fetchDetails);
        let result = await response.json();

        if(result['passed'] === 'fail'){
            setFormErrorText(result['reason'])
        }
        else{
            // Delete the existing Intent
            const updatedData = { ...intentData };
            delete updatedData[intentName];
            setIntentData(updatedData)

            updatedData[newKey] = newData;
            setIntentData(updatedData);
            setFormErrorText('')
            closeModal()
        }     
    };

    function closeModal(){
        handleClose()
        setFormErrorText('')
    }

    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="Edit-Framing-Intent"
            aria-describedby="Edit-Framing-Intent"
            sx={modalPosition}
        >
            <Box sx={modalContainer}>
                <h2>Edit {intentName}</h2>
                <Box component='form' onSubmit={handleSubmit}
                    autoComplete="off"
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap'
                    }}
                >
                    <FormField
                        name='Intent Label'
                        label='Intent Label'
                        fontSize='10px'
                        units=''
                        placeholder='Dailies 02'
                        defaultValue={intentName}
                        required
                    />
                    <FormField
                        name='Intent ID'
                        label='Intent ID'
                        fontSize='10px'
                        units=''
                        placeholder='dailies_02'
                        validationType='id'
                        defaultValue={intents["Intent ID"]}
                        required
                    />
                    <FormField
                        name='Aspect Ratio X'
                        label='Aspect Ratio X'
                        pair={true}
                        fontSize='10px'
                        units=''
                        placeholder='16'
                        validationType='number'
                        defaultValue={intents["Aspect Ratio X"]}
                    />
                    <FormField
                        name='Aspect Ratio Y'
                        label='Aspect Ratio Y'
                        pair={true}
                        fontSize='10px'
                        units=''
                        placeholder='9'
                        required
                        validationType='number'
                        defaultValue={intents["Aspect Ratio Y"]}
                    />
                    <FormField
                        name='Protection'
                        label='Protection'
                        fontSize='10px'
                        units=''
                        placeholder='0.00'
                        validationType='decimal'
                        required
                        defaultValue={intents["Protection"]}
                    />
                    <Box style={bottomButtonContainer}>
                        <FdlButton type='submit' text="Confirm Changes"></FdlButton>
                        <FdlButton style={cancelButtonStyle} text="Cancel" onClick={handleClose}></FdlButton>
                    </Box>
                    <Alert severity='error' style={formErrorTextStyle}>
                        <AlertTitle>Form submission error:</AlertTitle>
                        {formErrorText}
                    </Alert>
                </Box>
            </Box>
        </Modal>
    );
}